export default class Intercom {

    // FIXME send same props returned from backend
    static updateContactData = (props) => {
        let contactCustomProps =  {...props}

        // contact basic props should be sent as Intercom expected and its different from the props we use in GTM.
        // all custom attributes should be define only in site and send them here as is.
        const contactBasicProps = ['contactHashKey', 'contactId', 'contactName', 'contactEmail', 'contactPhone', 'event']
        contactBasicProps.forEach((prop) => {contactCustomProps && delete contactCustomProps[prop]})

        window.Intercom && window.Intercom('update', {
            user_hash: props.contactHashKey,
            user_id: props.contactId,
            name: props.contactName,
            email: props.contactEmail,
            phone: props.contactPhone,
            ...contactCustomProps
        })
    }

    static hide = () => {
        if (window.Intercom) {
            window.Intercom('hide')
            window.Intercom('update', {
                hide_default_launcher: true
            })
        }
    }

    static show = () => {
        window.Intercom && window.Intercom('update', {
            hide_default_launcher: false
        })
    }
}